import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from "@angular/core";
import { IrbEditorsService } from "@irb/irb-editors/irb-editors.service";
import { MatAccordion } from "@angular/material/expansion";
import { IEvent, IrbAppEvents, IrbEditorsEvents } from "@irb-common/events";
import { AppService } from "@irb/app.service";

@Component({ standalone: false,
  selector: "irb-editor-sidebar-banner",
  templateUrl: "./editor-sidebar-banner.component.html",
  styleUrls: ["./editor-sidebar-banner.component.scss", "../editor-sidebar/editor-sidebar.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class EditorSidebarBannerComponent {
  @Input() accordian: MatAccordion;
  @Input() showUnsavedChangesWarning: boolean;
  @Input() isModified: boolean;
  @Input() isValid: boolean;
  @Input() showExpandControls: boolean = true;
  @Input() hasPendingFunction: boolean = false;
  @Input() data: any;
  @Input() slot: string;
  @Input() saveLabel: string = "Save";
  @Input() saveWarning: string = "Unsaved Changes: You are about to leave without saving your changes.";
  @Input() proceedButtonLabel: string = "Proceed without saving";
  @Input() isSaveEnable: boolean = true;
  @Output() save = new EventEmitter<boolean>();
  @Output() cancel = new EventEmitter<boolean>();
  eventSubscription: any;

  constructor(public ies: IrbEditorsService, private as: AppService) {
  }

  closeWithoutSave() {
    this.as.fireEvent(IrbEditorsEvents.CLOSE_WITHOUT_SAVE, { 
      "hasPendingFunction": this.hasPendingFunction, 
      "data": this.data,
      "slot": this.slot
    });
  }

  onSave() {
    this.save.emit(true);
    
  }

  onCancel() {
    this.cancel.emit(true);
  }

}

